module.exports = __webpack_public_path__ + "static/media/HCMM473.865a82fc.jpg";